import { UserDelegation } from 'src/app/_user/components/user-delegation-picker/user-delegation-picker.component';
import { ParametresUserAppliModelDto } from 'src/graphql/generated-types';

const actionBaseName = '[User] ';

// <editor-fold defaultstate="collapsed" desc="Login / Logout">

export class LoginAction {
    static readonly type = actionBaseName + 'Login';

    constructor(public credentials: { login: string, password: string, ceName: string, storeCredentials?: boolean }) {
    }
}

export class LogoutAction {
    static readonly type = actionBaseName + 'Logout';
}

export class SaveUserLoginInformationsAction {
    static readonly type = actionBaseName + 'SaveUserLoginInformations';

    constructor(public loginInformations: UserDelegation) {
    }
}

export class CheckIfUserSuperAdminAction {
    static readonly type = actionBaseName + 'CheckIfUserSuperAdmin';

    constructor(public credentials: { login: string, password: string }) {
    }
}

export class CheckIfUserAdminInDelegationAction {
    static readonly type = actionBaseName + 'CheckIfUserSuperAdminInDelegation';
}

export class CheckIfUserFirstTimeLoginAction {
    static readonly type = actionBaseName + 'CheckIfUserFirstTimeLogin';
}

// </editor-fold>

export class GetCEListAction {
    static readonly type = actionBaseName + 'GetCEList';

    constructor(public credentials: { login: string, password: string }) {
    }
}

// <editor-fold defaultstate="collapsed" desc="Multi delegations">

export class GetMultiDelegationsListsAction {
    static readonly type = actionBaseName + 'GetMultiDelegationsListsAction';
}

// </editor-fold>

export class GetModulesListAction {
    static readonly type = actionBaseName + 'GetModulesList';
}

export class GetFunctionalitiesAndWidgetsAccessibleAction {
    static readonly type = actionBaseName + 'GetFunctionalitiesAndWidgetsAccessible';
}

export class GetPortalAccessBeneficiaryAction {
    static readonly type = actionBaseName + 'GetPortalAccessBeneficiary';
}

export class UserUpdateApplicationParametersAction {
    static readonly type = actionBaseName + 'UpdateApplicationParameters';

    constructor(public parameters: ParametresUserAppliModelDto[]) {
    }
}

export class UserUpdatePassword {
    static readonly type = actionBaseName + 'UpdatePassword';

    constructor(public newEncryptedPassword: string) {
    }
}

